import type { ReactNode } from 'react';
import React from 'react';
import { styled } from '@components-shared/src/stitches';
import type { IconButtonProps } from '@components/main-components/icon-buttons/IconButton';
import { IconButton } from '@components/main-components/icon-buttons/IconButton';

export function ChartCardAction({
  icon,
  onClick,
  actionSize = 'M',
  ...props
}: {
  icon: ReactNode;
  onClick?: () => void;
  actionSize?: 'M' | 'L';
} & IconButtonProps) {
  const buttonSize = actionSize === 'M' ? 24 : 32;
  const iconSize = actionSize === 'M' ? 16 : 20;
  return (
    <Action>
      <IconButton
        onClick={onClick}
        icon={icon}
        variant="primary"
        size={buttonSize}
        iconSize={iconSize}
        {...props}
      />
    </Action>
  );
}

const Action = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 32,
  height: 32,
});
